import { FunctionComponent, SVGProps } from 'react'

export const IconChevron: FunctionComponent<SVGProps<SVGSVGElement>> = (
  props
) => (
  <svg
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    stroke="#fcfcfc"
    {...props}
  >
    <path
      d="M15.0002 13.0241L10 8.02425L5.00017 13.0244"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
